var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlorMattress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3390_77778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 24.375C10.4759 24.375 11.875 22.9759 11.875 21.25C11.875 19.5241 10.4759 18.125 8.75 18.125C7.02411 18.125 5.625 19.5241 5.625 21.25C5.625 22.9759 7.02411 24.375 8.75 24.375Z",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 21.25V8.75C5.625 7.9212 5.95424 7.12634 6.54029 6.54029C7.12634 5.95424 7.9212 5.625 8.75 5.625C9.5788 5.625 10.3737 5.95424 10.9597 6.54029C11.5458 7.12634 11.875 7.9212 11.875 8.75V21.25",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 8.75H23.125C23.4565 8.75 23.7745 8.8817 24.0089 9.11612C24.2433 9.35053 24.375 9.66848 24.375 10V23.125C24.375 23.4565 24.2433 23.7745 24.0089 24.0089C23.7745 24.2433 23.4565 24.375 23.125 24.375H8.75",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21.5625C8.57741 21.5625 8.4375 21.4226 8.4375 21.25C8.4375 21.0774 8.57741 20.9375 8.75 20.9375",
    stroke: "#77838D",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21.5625C8.92259 21.5625 9.0625 21.4226 9.0625 21.25C9.0625 21.0774 8.92259 20.9375 8.75 20.9375",
    stroke: "#77838D",
    strokeWidth: 1.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3390_77778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlorMattress);
export default __webpack_public_path__ + "static/media/flor_mattress.957fcedd.svg";
export { ForwardRef as ReactComponent };